/**
 * InGo's brand images, bundled with the app (InGo, 2 Oct 2026): the app no
 * longer reads them from the old system's storage, so they draw with Supabase
 * gone (the app's ADR 0012, consequences). The same files as before, copied
 * from that public bucket into `public/images/`.
 */
const base = process.env.PUBLIC_URL || '';

/** Public InGo brand logo. */
export const INGO_LOGO_URL = `${base}/images/ingo-logo.png`;

/** Login / register hero banner: an InGo scooter and car, both delivering. */
export const LOGIN_HERO_ART = `${base}/images/ingo-login-hero.png`;

/** @deprecated Use LOGIN_HERO_ART — single banner only */
export const LOGIN_HERO_ICONS = [LOGIN_HERO_ART];
